import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	details: {
		defaultMessage: 'Details',
		id: 'spa-apps.project-settings.common.shared-document-title.details',
		description: 'Section label to follow the project name in the window title',
	},
	people: {
		defaultMessage: 'Access',
		id: 'spa-apps.project-settings.common.shared-document-title.people',
		description: 'Section label to follow the project name in the window title',
	},
	issueType: {
		defaultMessage: 'Issue types',
		id: 'spa-apps.project-settings.common.shared-document-title.issue-type',
		description: 'Section label to follow the project name in the window title',
	},
	configureIssue: {
		defaultMessage: 'Configure issue',
		id: 'spa-apps.project-settings.common.shared-document-title.configure-issue',
		description: 'Action label to precede the project name in the window title',
	},
	notifications: {
		defaultMessage: 'Notifications',
		id: 'spa-apps.project-settings.common.shared-document-title.notifications',
		description: 'Section label to follow the project name in the window title',
	},
	notificationEmail: {
		defaultMessage: 'Notification email',
		id: 'spa-apps.project-settings.common.shared-document-title.notification-email',
		description: 'Section label to follow the project name in the window title',
	},
	features: {
		defaultMessage: 'Features',
		id: 'spa-apps.project-settings.common.shared-document-title.features',
		description: 'Section label to follow the project name in the window title',
	},
	connectAppControls: {
		defaultMessage: 'Apps',
		id: 'spa-apps.project-settings.common.shared-document-title.connect-app-controls',
		description: 'Section label to follow the project name in the window title',
	},
	proformaForms: {
		defaultMessage: 'Forms',
		id: 'spa-apps.project-settings.common.shared-document-title.proforma-forms',
		description: 'Section label to follow the project name in the window title',
	},
	connections: {
		defaultMessage: 'Connections',
		id: 'spa-apps.project-settings.common.shared-document-title.connections',
		description: 'Section label to follow the project name in the window title',
	},
	toolchain: {
		defaultMessage: 'Toolchain',
		id: 'spa-apps.project-settings.common.shared-document-title.toolchain',
		description: 'Section label to follow the project name in the window title',
	},
	dataClassifications: {
		defaultMessage: 'Data classifications',
		id: 'spa-apps.project-settings.common.shared-document-title.data-classifications',
		description: 'Section label to follow the project name in the window title',
	},
	// EAX-256 - Finalise this string
	fieldsNonFinal: {
		defaultMessage: 'Fields',
		id: 'spa-apps.project-settings.common.shared-document-title.fields-non-final',
		description:
			'Section label to follow the project name in the window title - used for the "Fields" settings page TMP project settings',
	},
});
